@if (breadcrumbs().length > 0) {
<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>{{ currentPageTitle }}</h2>
    <ol class="breadcrumb">
      @for (crumb of breadcrumbs(); track crumb.label; let last = $last) {
        @if (!last) {
          <li class="breadcrumb-item">
            @if (crumb.url) {
              <a [routerLink]="crumb.url">{{ crumb.label }}</a>
            } @else {
              <a>{{ crumb.label }}</a>
            }
          </li>
        } @else {
          <li class="breadcrumb-item active">
            <strong>{{ crumb.label }}</strong>
          </li>
        }
      }
    </ol>
  </div>
</div>
}